import script from "./SearchFormComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchFormComponent.vue?vue&type=script&setup=true&lang=js"

import "./SearchFormComponent.vue?vue&type=style&index=0&id=104899c9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-104899c9"]])

export default __exports__